import type { NavigateFunction } from 'react-router-dom';
import {
  AuthSessionExpiredHandledError,
  forceLogoutAndRedirect,
  handleUnauthorizedResponseIfPresent,
  isAuthSessionExpiredHandledError,
  isUnauthorizedApiResponse,
} from './authSession';
import { toastManager } from './notifications';

export { AuthSessionExpiredHandledError, isAuthSessionExpiredHandledError };

export const TUTOR_SESSION_EXPIRED_USER_MESSAGE =
  'Your session has expired. Please log in again.';

/**
 * True when the tutor session-token response indicates invalid/expired app auth.
 * Call only after `handleSchoolFeatureDisabledIfPresent` so 403 + FEATURE_NOT_ENABLED is not misclassified.
 */
export function tutorSessionTokenResponseIsAuthFailure(status: number, bodyText: string): boolean {
  return isUnauthorizedApiResponse(status, bodyText);
}

export function performTutorSessionExpiredLogout(navigate?: NavigateFunction): void {
  toastManager.warning(TUTOR_SESSION_EXPIRED_USER_MESSAGE);
  forceLogoutAndRedirect(navigate);
}

/**
 * If the response is an auth failure, clears session, toasts, navigates to login.
 * @returns whether auth-expired handling ran (caller should throw {@link AuthSessionExpiredHandledError}).
 */
export function handleTutorSessionTokenAuthExpiredIfPresent(options: {
  status: number;
  bodyText: string;
  navigate?: NavigateFunction;
}): boolean {
  if (
    !handleUnauthorizedResponseIfPresent({
      status: options.status,
      bodyText: options.bodyText,
      navigate: options.navigate,
    })
  ) {
    return false;
  }

  toastManager.warning(TUTOR_SESSION_EXPIRED_USER_MESSAGE);
  return true;
}
